import { QueryClient } from '@tanstack/react-query';

/**
 * React Query client configuration
 * Optimized for Elly Tails app requirements
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Stale time: how long before data is considered stale
      staleTime: 5 * 60 * 1000, // 5 minutes
      
      // Cache time: how long inactive data stays in cache
      cacheTime: 10 * 60 * 1000, // 10 minutes
      
      // Retry configuration
      retry: 1,
      retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 30000),
      
      // Don't refetch on window focus by default
      refetchOnWindowFocus: false,
      
      // Don't refetch on reconnect by default
      refetchOnReconnect: 'always',
    },
    mutations: {
      // Retry failed mutations once
      retry: 1,
    },
  },
});

/**
 * Query key factory for consistent key generation
 */
export const queryKeys = {
  // Word queries
  words: {
    all: ['words'],
    search: (query) => ['words', 'search', query],
    detail: (word) => ['words', 'detail', word],
    analytics: (word) => ['words', 'analytics', word],
    stories: (word) => ['words', 'stories', word],
  },
  
  // Story queries
  stories: {
    all: ['stories'],
    list: (filters) => ['stories', 'list', filters],
    detail: (id) => ['stories', 'detail', id],
    progress: (id) => ['stories', 'progress', id],
  },
  
  // User queries
  user: {
    current: ['user', 'current'],
    profile: ['user', 'profile'],
    analytics: ['user', 'analytics'],
    preferences: ['user', 'preferences'],
  },
  
  // Grammar queries
  grammar: {
    lessons: ['grammar', 'lessons'],
    lesson: (id) => ['grammar', 'lesson', id],
  },
};